import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppStoreFeatureName, MultiStageAssignmentReportState, State } from './multi-stage-assignment-report.model';

export const selectMultiStageAssignmentReportState = createFeatureSelector< MultiStageAssignmentReportState>(
    AppStoreFeatureName.MultiStageAssignmentReport
);

export const selectIsAuthenticated = createSelector(selectMultiStageAssignmentReportState, (state) => state.isAuthenticated);

export const selectIsLoading = createSelector(selectMultiStageAssignmentReportState, (state) => state.isLoading);

export const selectUserRole = createSelector(selectMultiStageAssignmentReportState, (state) => state.userRole);

export const selectOverallReportData = createSelector(
    selectMultiStageAssignmentReportState,
    (state) => state.overallReportData
);

export const selectStudentsReportData = createSelector(
    selectMultiStageAssignmentReportState,
    (state) => state.studentsReportData
);

export const selectMetricMeasureData = createSelector(
    selectMultiStageAssignmentReportState,
    (state) => state.metricMeasureData
);

export const selectStudentsNotCompletedData = createSelector(
    selectMultiStageAssignmentReportState,
    (state) => state.studentsNotCompletedData
);

export const selectMetricsClassAverage = createSelector(
    selectMultiStageAssignmentReportState,
    (state) => state.metricsClassAverage
);

export const selectAssessmentReportingType = createSelector(
    selectMultiStageAssignmentReportState,
    (state) => state.assessmentReportingType
);

export const selectAssessmentSequence = createSelector(
    selectMultiStageAssignmentReportState,
    (state) => state.assessmentSequence
);

export const selectLanguageLocale = createSelector(
    selectMultiStageAssignmentReportState,
    (state) => state.languageLocale
);

export const selectIsErrorOccurred = createSelector(
    selectMultiStageAssignmentReportState,
    (state) => state.isErrorOccurred
);

export const selectAssessmentDetails = createSelector(
    selectMultiStageAssignmentReportState,
    (state) => state.assessmentDetails
);

export const selectUserFeatureAttributes = createSelector(
    selectMultiStageAssignmentReportState,
    (state) => state.userFeatureAttributes
);

export const selectIsZeroState = createSelector(selectMultiStageAssignmentReportState, (state) => state.isZeroState);

export const selectStandardMetadata = createSelector(
    selectMultiStageAssignmentReportState,
    (state) => state.standardMetadata
);

export const selectStandardsModalPayload = createSelector(selectMultiStageAssignmentReportState, (state) => state.standardsModalPayload);

export const selectIsStandardModalVisible = createSelector(selectMultiStageAssignmentReportState, (state)=>state.isStandardModalVisible);

export const selectInputParams = createSelector(
    selectMultiStageAssignmentReportState,
    (state) => state.inputParams,
);
